"use client";

// KAN-973/KAN-1320: словарь приходит клиенту отдельным чанком на локаль, а не
// строкой в HTML каждой страницы. Чанк хешированный — браузер кэширует его между
// страницами и визитами. Файл на локаль, чтобы в чанк попадал только свой язык.
// KAN-975: здесь только основная часть словаря. Группы, нужные одному семейству маршрутов (админка),
// лежат в messages/generated/ и подгружаются слоем сообщений вместе с кодом семейства.
// Пересборка после правки словаря или использования групп: pnpm run messages:split.
import base from "../../messages/generated/en.core.json";
import errors from "../../messages/errors/en.json";

import { RootContent, type RootContentProps } from "./root-content";

const messages = { ...base, Errors: errors };

export function RootContentEn(props: Omit<RootContentProps, "locale" | "messages">) {
  return <RootContent {...props} locale="en" messages={messages} />;
}
